/**
 * BOTTOM GENERAL INITS
 * STRUCTURE
 */

import { CardSlider } from "./cardSlider";


export class CardInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        $('.card-slider').each((i, el) => {
            new CardSlider(el);
        })
    }
}
